require([
    'services',
    'jquery',
    'semantic',
    'ch_header',
    'ch_form_validation',
    'ch_semantic_responsive',
    'ch_welcome_overlay'
], function () {

    // Local variables
    var $emails = $('#emails');
    var $nameSection = $('#name_section');
    var $name = $('#name');
    var $referralLink = $('#referral_link');
    var $copyButton = $('#copy-button');

    function referralSuccess(res) {
        if (res.success) {
            $emails.val('');
            $nameSection.hide();

            if(!res.sent_emails) {
                var ModalWindowReferralConfirmationFailureObj = new ModalWindowReferralConfirmationFailure();
                ModalWindowReferralConfirmationFailureObj.show({
                    onShow: function () {
                        var confirmationWindow = ModalWindowReferralConfirmationFailureObj.window;
                        confirmationWindow.find('.friends').html(res.friends);

                        if(res.pre_existing_emails_count < 2) {
                            confirmationWindow.find('#know').html('knows');
                            confirmationWindow.find('#have').html('has');
                        } else {
                            confirmationWindow.find('#know').html('know');
                            confirmationWindow.find('#have').html('have');
                        }
                    },
                    autofocus: false
                });
            } else {
                var ModalWindowReferralConfirmationObj = new ModalWindowReferralConfirmation();
                ModalWindowReferralConfirmationObj.show({
                    onShow: function () {
                        var confirmationWindow = ModalWindowReferralConfirmationObj.window;
                        confirmationWindow.find('#friends').html(res.friends);

                        if (res.pre_existing_emails) {
                            confirmationWindow.find('#preExistingEmails').html(res.pre_existing_emails);
                        } else {
                            confirmationWindow.find('#preExistingEmails').html('');
                        }
                    },
                    autofocus: false
                });
            }

        } else {
            swal({
                title: res.error,
                type: "error",
                confirmButtonText: "Ok"
            });
        }
    }

    function initEventHandlers() {
        var ModalWindowRegisterObj = new ModalWindowRegister();

        // Display sign-up modal if user not logged in
        $('#sign-up').on('click', function() {
            ModalWindowRegisterObj.show();
        });

        $copyButton.on('click', function (e) {
            e.preventDefault();
            $referralLink.select();
            document.execCommand('copy');
        });
    }

    function initForm() {
        // Form validator and submit handler
        var formValidator = CH.validate('form_Referral', {
            submitHandler: function () {
                $.ajax({
                    url: '/user/Account/referral-post',
                    type: 'POST',
                    async: false,
                    dataType: 'json',
                    data: {
                        emails: $emails.val(),
                        referral_link: $referralLink.val(),
                        name: $name.val()
                    },
                    success: referralSuccess
                });
            }
        });

        $copyButton.html('Select');
    }

    $(function () {
        initEventHandlers();
        initForm();
    });
});
